import React, { Component, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import classNames from 'classnames';
import { connect } from 'react-redux';
import localStorage from '../../libs/storageHelper';

import { toggleLoading } from '../../redux/actions/commonActions';
import { SortingField } from '../common/SortingCell';
import { isSuperAdmin } from '../../utils/Utils';
import { FACILITY_INVITATION_STATUS } from '../../constants/constants';

const TableRow = ({
  heads,
  item,
  viewProfile = () => {},
  handleActiveStatus,
}) => {
  if (!item.username) {
    item.username = item.email;
  }

  const status = (item.status || '').toLowerCase();
  const showActivate = status === FACILITY_INVITATION_STATUS.inactive;
  const showDeactivate = status === FACILITY_INVITATION_STATUS.active;

  const handleStatusChange = useCallback(
    (nextStatus, event) => {
      if (event) event.stopPropagation();
      if (!handleActiveStatus) return;
      handleActiveStatus(
        nextStatus,
        item.id,
        item.fullName || item.username,
      );
    },
    [handleActiveStatus, item],
  );

  return (
    <tr
      className="body-tr staff-row"
      key={item.id}
      onClick={() => viewProfile(item)}
      style={{ cursor: 'pointer' }}
    >
      {heads.filter(Boolean).map(({ key, capitalize, transform, className }) => (
        <td
          key={key}
          className={classNames(className, {
            'text-capitalize': !!capitalize,
          })}
        >
          {typeof transform === 'function'
            ? transform(item[key], item)
            : item[key]}
        </td>
      ))}
      {handleActiveStatus && (
        <td
          className="staff-action-column"
          style={{ whiteSpace: 'nowrap' }}
          onClick={(e) => e.stopPropagation()}
        >
          {showActivate && (
            <a
              href="#activate"
              onClick={(e) => {
                e.preventDefault();
                handleStatusChange(FACILITY_INVITATION_STATUS.active, e);
              }}
            >
              Activate
            </a>
          )}
          {showDeactivate && (
            <a
              href="#deactivate"
              onClick={(e) => {
                e.preventDefault();
                handleStatusChange(FACILITY_INVITATION_STATUS.inactive, e);
              }}
            >
              Deactivate
            </a>
          )}
        </td>
      )}
    </tr>
  );
};

class StaffTableComponent extends Component {
  static propTypes = {
    heads: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
        sortable: PropTypes.bool,
      }),
    ).isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loggedUser: localStorage.getFromStorage('loggedUser'),
    };
  }

  UNSAFE_componentWillMount() {
    this.props.toggleLoading(true);
  }

  componentWillUnmount() {
    if (this.props.common.loading) {
      this.props.toggleLoading(false);
    }
  }

  render() {
    const {
      rows,
      heads,
      sortField,
      sortOrder,
      viewProfile,
      handleActiveStatus,
    } = this.props;
    const { loggedUser } = this.state;

    const headers = heads.filter(Boolean).map((head, key) => {
      const thClass = head.className ?? '';
      return head.sortable && !head.filterable ? (
        <th key={key} className={thClass}>
          {sortField === head.key ? (
            <SortingField
              icon={sortOrder === 1 ? 'triangle-up' : 'triangle-down'}
              name={head.name}
              onSort={() => this.props.handleGridSort(head.key)}
            />
          ) : (
            <div
              className="sort-field"
              onClick={() => this.props.handleGridSort(head.key)}
            >
              <p>{head.name}</p>
              <div>
                {(isSuperAdmin(loggedUser) &&
                  head.key === 'facilityDisplayName') || (
                  <span className="diamond-narrow" />
                )}
              </div>
            </div>
          )}
        </th>
      ) : (
        <th key={key} className={thClass}>
          <p>{head.name}</p>
        </th>
      );
    });

    if (handleActiveStatus) {
      headers.push(
        <th key="action" className="staff-action-column">
          <p>Action</p>
        </th>,
      );
    }

    const hasFacility = heads.some(
      (head) => head && head.key === 'facilityDisplayName',
    );
    const hasAction = !!handleActiveStatus;
    const tableClassName = classNames(
      'custom-table',
      'loyal-table',
      'fixed-layout',
      {
        'staff-table--facility': hasFacility,
        'staff-table--action': hasAction,
      },
    );

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="staff-table-scroll">
            <Table striped className={tableClassName}>
              <thead>
                <tr className="header-tr" style={{ top: '180px' }}>
                  {headers}
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <TableRow
                    key={row.id}
                    heads={heads}
                    item={row}
                    viewProfile={viewProfile}
                    handleActiveStatus={handleActiveStatus}
                  />
                ))}
              </tbody>
            </Table>
          </div>
          {rows.length === 0 && this.props.common.loading === false && (
            <div className="no-data-message">No results found</div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
});

const mapDispatchToProps = {
  toggleLoading,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StaffTableComponent);
